import { ToWords } from "to-words/en-IN";
import type { ReceiptLineItem } from "@/components/common-receipt/CommonReceiptA5";
import {
  defaultA5ChromeProps,
  onlineOrPlainPaymentText,
} from "@/components/common-receipt/a5-print-defaults";

const toWords = new ToWords();

export type YearlyLedgerPrintRow = {
  id?: string;
  financialYear?: string;
  receiptNo?: string | null;
  receiptDate?: string;
  receiptType?: string;
  paymentMode?: string;
  paymentRef?: string | null;
  amount?: number;
  purpose?: string | null;
  name?: string | null;
  itsNo?: string | null;
  remarks?: string | null;
  updatedBy?: string | null;
  yearlyLedgerType?: {
    name?: string;
  } | null;
};

export function yearlyLedgerPaymentText(data: YearlyLedgerPrintRow): string {
  return onlineOrPlainPaymentText(data.paymentMode || "CASH", data.paymentRef);
}

export function yearlyLedgerReceiptLines(data: YearlyLedgerPrintRow): ReceiptLineItem[] {
  const isCredit = data.receiptType === "CREDIT";
  const partyName = [data.name, data.itsNo ? `(ITS - ${data.itsNo})` : ""]
    .filter(Boolean)
    .join(" ");
  const paymentText = yearlyLedgerPaymentText(data);

  return [
    {
      left: isCredit ? "Received from" : "Paid to",
      right: partyName || "—",
      bold: true,
    },
    {
      left: "The sum of Rupees",
      right: `${toWords.convert(Number(data.amount) || 0)} Only`,
      bold: true,
    },
    {
      left: isCredit ? "Received by" : "Paid by",
      right: paymentText,
      capitalize: true,
    },
    {
      left: "Towards",
      right: data.purpose || "—",
    },
    {
      left: "Remarks",
      right: data.remarks || "—",
    },
  ];
}

export function yearlyLedgerEntryA5Props(data: YearlyLedgerPrintRow) {
  const isCredit = data.receiptType === "CREDIT";
  const ledgerTypeName = data.yearlyLedgerType?.name || "Yearly Ledger";

  return {
    ...defaultA5ChromeProps(),
    subTitle: ledgerTypeName,
    receiptNo: data.receiptNo != null ? String(data.receiptNo) : undefined,
    date: data.receiptDate,
    receiptLines: yearlyLedgerReceiptLines(data),
    amount: Number(data.amount),
    digitalSignatureValue: `${String(data.id)}|${String(data.updatedBy ?? "")}`,
    receiptHeaderText: isCredit ? "CREDIT RECEIPT" : "DEBIT VOUCHER",
  };
}
